<script>
import RichText from "@/components/ui/RichText.vue";
import FileCard from "@/components/events/FileCard.vue";

export default {
  name: "PastEventDetails",
  components: {FileCard, RichText},
  props: ["event"],
  data: () => ({
    lightboxVisible: false,
  }),
  computed: {
    apiUrl() {
      return process.env.VUE_APP_API_BASE_URL;
    },
    files() {
      const items = [];

      if(this.event?.Praesentation) items.push(this.event.Praesentation);
      if(this.event?.Medien) items.push(...this.event.Medien);

      return items;
    },
    sanitizedYoutubeIframe() {
      if(!this.event?.LinkAufzeichnung) return undefined;
      return this.event.LinkAufzeichnung.replace(/<iframe\b[^>]*>/i, tag => {
        // 1) drop width/height attributes
        let t = tag.replace(/\s+(?:width|height)\s*=\s*(?:"[^"]*"|'[^']*'|[^\s>]+)/gi, '');

        // 2) add or merge style (remove existing width/aspect-ratio to avoid conflicts)
        if (/style\s*=/.test(t)) {
          t = t.replace(/style\s*=\s*(['"])([\s\S]*?)\1/i, (m, q, css) => {
            css = css.replace(/(?:^|;)\s*(?:width|aspect-ratio)\s*:[^;]*;?/gi, '').trim();
            if (css && !css.endsWith(';')) css += ';';
            return `style=${q}${css ? css + ' ' : ''}width: 100%; aspect-ratio: 16/9;${q}`;
          });
        } else {
          t = t.replace(/>$/, ' style="width: 100%; aspect-ratio: 16/9;">');
        }
        return t;
      });
    },
  }
}
</script>

<template>
  <div class="pa-5">
    <div v-if="event.Praesentation">
      <div class="font-weight-bold mb-2">Präsentation</div>
      <div class="pdf-viewer-container">
      <embed type="application/pdf" width="100%" style="display: block; aspect-ratio: 16/9" :src="`${apiUrl}${event.Praesentation.url}`" />
      <div style="height: 36px; width: 100%; display: flex; justify-content: flex-end;">
        <v-btn color="white" icon @click="() => lightboxVisible = true">
          <v-icon>mdi-fullscreen</v-icon>
        </v-btn>
      </div>
      </div>
      <rich-text :markdown-text="event.AnmerkungPraesentation" />
      <v-dialog v-model="lightboxVisible" width="80vw">
        <embed type="application/pdf" style="display: block; height: 80vh" :src="`${apiUrl}${event.Praesentation.url}`" />
      </v-dialog>
    </div>
    <div v-if="sanitizedYoutubeIframe">
      <div class="font-weight-bold mb-2 mt-10">Aufzeichnung</div>
      <div class="yt-container" v-html="sanitizedYoutubeIframe" />
      <rich-text :markdown-text="event.AnmerkungAufzeichnung" />
    </div>
    <div v-if="files.length > 0">
      <div class="font-weight-bold mb-2 mt-10">Downloads</div>
      <file-card class="mb-2" v-for="file of files" :key="file.id" :name="file.name" :ext="file.ext" :size="file.size" :url="file.url" />
    </div>
  </div>
</template>

<style scoped>
.pdf-viewer-container {
  background-color: rgb(53, 53, 53);
}
</style>